import React from "react";
import { Sparkles } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useLocation } from "react-router-dom";

export default function PostRequirementFAB() {
  const { openRequirement } = useAuth();
  const { pathname } = useLocation();

  // Hide on dashboards (already available inside them) and on sell page
  if (pathname.startsWith("/admin") || pathname.startsWith("/broker") || pathname.startsWith("/dashboard") || pathname.startsWith("/sell") || pathname.startsWith("/auth")) {
    return null;
  }

  return (
    <button
      onClick={openRequirement}
      data-testid="fab-post-requirement"
      aria-label="Post your property requirement"
      className="fixed bottom-5 right-5 z-40 group flex items-center gap-2 pl-3 pr-4 py-3 bg-ink text-gold border-2 border-gold hover:bg-gold hover:text-ink transition-all duration-300 shadow-2xl"
    >
      <span className="w-6 h-6 flex items-center justify-center bg-gold text-ink group-hover:bg-ink group-hover:text-gold transition-colors">
        <Sparkles className="w-3.5 h-3.5" />
      </span>
      <span className="text-xs font-semibold uppercase tracking-widest hidden sm:inline">Post Requirement</span>
      <span className="text-xs font-semibold uppercase tracking-widest sm:hidden">Requirement</span>
    </button>
  );
}
